import { all, fork } from 'redux-saga/effects';
import ndfl2Reduces from '../../UserIncomes/redux/2ndfl/reducer';
import ndfl2Saga from '../../UserIncomes/redux/2ndfl/saga';
import insuranceTaxesReducer from '../../UserIncomes/redux/insuranceTaxes/reducer';
import insuranceTaxesSaga from '../../UserIncomes/redux/insuranceTaxes/saga';
import incomeInformations from '../../UserIncomes/redux/incomeInformations/reducer';
import incomeInformationsSaga from '../../UserIncomes/redux/incomeInformations/saga';
import percentDepositsSaga from '../../UserIncomes/redux/percentDeposits/saga';
import percentDepositsReducer from '../../UserIncomes/redux/percentDeposits/reducer';
import userIncomes from '../../UserIncomes/redux/userIncomes/reducer';
import userIncomesSaga from '../../UserIncomes/redux/userIncomes/saga';

export const userIncomesReducers = {
  ndfl2: ndfl2Reduces,
  insuranceTaxes: insuranceTaxesReducer,
  incomeInformations,
  userIncomes,
  percentDeposits: percentDepositsReducer,
};

export function* userIncomesSagas() {
  yield all(
    [
      ndfl2Saga,
      insuranceTaxesSaga,
      incomeInformationsSaga,
      userIncomesSaga,
      percentDepositsSaga,
    ].map(function (saga) {
      return fork(saga);
    }),
  );
}
